<template>
    <div>
        <div class="page beers elementStandard elementContent elementForm elementForm_var0">
            <h2>{{ __("page_setbeers.pagetitle") }}</h2>
            <form name="beerform" class="form-horizontal form-beer-registration">
                <dl class="form">
                    <div class="row">
                        <div class="errorMessages" v-if="!value.length">
                            <ErrorMessage>{{ __("page_setbeers.error.nobeer") }}</ErrorMessage>
                        </div>
                    </div>
                    <BeerRecord v-for="(v, key) in value" :key="key" :index="key"
                                v-model="value[key]"
                                :validator="validators[key]"
                                v-on:remove="removeBeer(key)"
                                @nameChanged="handleNameChange"
                                :nameError="errorMessages[key]"/>
                    <dd>
                        <button class="btn-primary L" style="margin-left: 0;" v-on:click="addBeer" type="button">
                            {{ __("page_setbeers.addbeer") }}
                        </button>
                    </dd>
                </dl>
                <footer>

                    <button class="left btn-secondary" @click="$emit('back'); scrollToTop();" type="button">
                        <!-- eslint-disable-next-line vue/no-parsing-error -->
                        <span>< {{ __('common.button_back') }}</span>
                    </button>

                    <button @click="validateAndSubmitForm(); scrollToTop();" type="button" class="buttonSubmitAlign right btn-secondary">
                        <span>{{ __("common.button_continue") }} ></span>
                    </button>
                </footer>
            </form>
        </div>
    </div>
</template>

<script>
    import ErrorMessage from "./ErrorMessage";
    import BeerRecord from "./BeerRecord";
    import Beer from "../domain/beer";
    import BeerRecordValidator from "../validators/BeerRecordValidator";
    import _ from 'lodash';
    import Lang from "../mixins/Lang";


    export default {
        name: "BeerForm",
        components: {BeerRecord, ErrorMessage},
        props: ['value'],
        store: ['additionalBeerCategoriesWithBeerType', 'categories'],
        mixins: [Lang],

        created() {
            if (!this.value.length) {
                var initialBeer = new Beer();
                this.value.push(initialBeer);
                this.validators.push(new BeerRecordValidator(initialBeer, this.value, this.categories, this.additionalBeerCategoriesWithBeerType));
            } else {
                _.each(this.value, (beer) => {
                    this.validators.push(new BeerRecordValidator(beer, this.value, this.categories, this.additionalBeerCategoriesWithBeerType));
                });
            }
        },

        watch: {
            categories() {
                _.each(this.validators, (validator) => {
                    validator.categories = this.categories;
                });
            }
        },

        methods: {
            addBeer() {
                var beer = new Beer();
                this.value.push(beer);
                this.validators.push(new BeerRecordValidator(beer, this.value, this.categories, this.additionalBeerCategoriesWithBeerType));
            },

            removeBeer(key) {
                this.value.splice(key, 1);
                this.validators.splice(key, 1);
            },

            cleanBeerFields (beer) {
                // eslint-disable-next-line no-unused-vars
                var category = _.find(this.categories, (category) => category.id === beer.category );
            },

            validateAndSubmitForm() {
                _.each(this.validators, (validator) => validator.validateAll());
                var isValid = _.every(this.validators, (validator) => _.every(validator.errors, (value) => value === ''));
                if(!isValid) return;
                
                // Check for duplicate beer names
                let beerNames = this.value.map(beer => beer.name);
                let hasDuplicates = new Set(beerNames).size !== beerNames.length;
                if(hasDuplicates) return;

                // get names and categories from beers
                beerNames = this.value.map(beer => [beer.name, beer.category]);
                // get company from localstorage
                let companyName = JSON.parse(localStorage.getItem('companyName'));
            
                let beerNameDuplicateApi = (new BeerRecordValidator()).validateBeerName(beerNames, companyName);
                
                // if response successful
                beerNameDuplicateApi.then((res)=>{
                    if(res.status == 200){
                        _.each(this.value, (beer) => {this.cleanBeerFields(beer);});
                        this.$emit('submitBeerForm');
                    }
                });
                // if response returns error
                beerNameDuplicateApi.catch((err)=>{
                    
                    let dupedArr = [];

                    for (const [key, value] of Object.entries(err.response.data.message)) {
                        dupedArr[key] = "";
                        value.forEach((e) => {
                            if(e != null && e != undefined && e != "" && e != 0 && e != "0"){
                                dupedArr[key] = e;
                            }
                        });
                        
                    }
                    console.log(dupedArr)

                    this.validators.forEach((validator, index) => {
                        if(validator.record.name in dupedArr){
                            validator.errors.name = dupedArr[validator.record.name];
                        }
                    });

                });

                


                
            },

            handleNameChange({ name, index }) {
                let duplicate = this.value.some((beer, idx) => beer.name === name && idx !== index);
                this.validators.at(index).errors.name = duplicate ? "page_setbeers.error.beerduplicated" : "";
            },

            scrollToTop() {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }

        },

        data: function () {
            return {
                validators: [],
                errorMessages: [] 
            }
        }
    }
</script>

<style lang="scss">
    button.buttonSubmit {
        &.right {
            span {
                margin-right: 5px;
            }
        }

        &.left {

            span {
                margin-left: 5px;
            }
        }
    }
</style>